import React, {useEffect} from 'react';
import {useParams, Navigate} from 'react-router-dom';
import {useStoreActions} from 'easy-peasy';
import {buildURL} from '@/utils/urlBuilder';

interface CustomerDetailViewProps {
  params?: any;
  children?: React.ReactNode;
}

const CustomerDetailView: React.FC<CustomerDetailViewProps> = React.memo(({params: propParams, children}) => {
    const urlParams = useParams();
    const setActiveStoryObject = useStoreActions((actions: any) => actions.activeStoryObject.setActiveStoryObject);
    
    const customerId = propParams?.customerId || urlParams.customerId;
    
    useEffect(() => {
        if (customerId) {
            setActiveStoryObject(customerId);
        }
    }, [customerId, setActiveStoryObject]);

    if (!customerId) {
        return <Navigate to={buildURL('customersListView')} replace />;
    }

    return <div>{children}</div>;
});

export default CustomerDetailView;
